import {
  Database,
  Users,
  ShieldCheck,
  Sparkles,
  Crown,
  LucideIcon,
} from "lucide-react"

export type RoleMap = {
  catalogRoleRef: number
  name: string
  icon: LucideIcon
}

export const catalogRoleMaps: RoleMap[] = [
  {
    catalogRoleRef: 1,
    name: "Data Producer",
    icon: Database,
  },
  {
    catalogRoleRef: 2,
    name: "Sales Operator",
    icon: Users,
  },
  {
    catalogRoleRef: 3,
    name: "Operator Admin",
    icon: ShieldCheck,
  },
  {
    catalogRoleRef: 11,
    name: "Solution Specialist",
    icon: Sparkles,
  },
]

/**
 * Get the icon component for a role name
 */
export function getRoleIcon(roleName: string): LucideIcon | undefined {
  // Handle special "Admin" role
  if (roleName === "Admin") {
    return Crown
  }
  const role = catalogRoleMaps.find((r) => r.name === roleName)
  return role?.icon
}

/**
 * Get the role map for a role name
 */
export function getRoleMap(roleName: string): RoleMap | undefined {
  return catalogRoleMaps.find((r) => r.name === roleName)
}
